import { createGlobalStyle } from "styled-components";

import pixelToRem from "../utils/pxToRem";
import { device } from "./responsive";

export const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Core palette */
  --bg-main: #111111;
  --bg-surface: #191919;
  --bg-elevated: #202020;
  --text-primary: #f5f5f5;
  --text-secondary: #bdbdbd;
  --brand-red: #b63b30;
  --brand-red-hover: #ca4a3e;
  --brand-orange: #d08a3c;
  --cta-green: #22c55e;
  --cta-green-hover: #16a34a;
  --border-soft: #2c2c2c;
  --shadow-soft: 0 10px 30px rgba(0, 0, 0, 0.28);

  /* Legacy aliases to keep existing components stable */
  --text: var(--text-primary);
  --gray-05: var(--text-secondary);
  --sun: var(--brand-red);
  --mars: var(--brand-red);
  --mars-light: var(--brand-red-hover);
  --mars-dark: #93261f;
  --earth: var(--cta-green);
  --color-whats: var(--cta-green);
  --background: var(--bg-main);
  --background-section: linear-gradient(180deg, #141414 0%, #111111 100%);
  --background-form: var(--bg-elevated);

  /* Typography scale */
  --font-display: 800 ${pixelToRem(62)}/${pixelToRem(72)} "Manrope", sans-serif;
  --font-heading-1: 700 ${pixelToRem(34)}/${pixelToRem(44)} "Manrope", sans-serif;
  --font-heading-2: 600 ${pixelToRem(26)}/${pixelToRem(36)} "Manrope", sans-serif;
  --font-heading-3: 500 ${pixelToRem(20)}/${pixelToRem(32)} "Manrope", sans-serif;
  --font-mobile-heading-1: 800 ${pixelToRem(38)}/${pixelToRem(46)} "Manrope", sans-serif;
  --font-mobile-text-1: 500 ${pixelToRem(14)}/${pixelToRem(22)} "Manrope", sans-serif;
  --text-4: 600 ${pixelToRem(16)}/${pixelToRem(24)} "Manrope", sans-serif;
  --text-3: 600 ${pixelToRem(17)}/${pixelToRem(24)} "Manrope", sans-serif;
  --text-2: 500 ${pixelToRem(14)}/${pixelToRem(20)} "Manrope", sans-serif;
  --text-1: 400 ${pixelToRem(16)}/${pixelToRem(26)} "Manrope", sans-serif;
  --text-0: 400 ${pixelToRem(14)}/${pixelToRem(22)} "Manrope", sans-serif;
}

/* Base document settings */
body {
  font-family: "Manrope", sans-serif;
  -webkit-font-smoothing: antialiased;
  background:
    radial-gradient(circle at 8% 9%, rgba(255, 92, 67, 0.2) 0%, transparent 38%),
    radial-gradient(circle at 86% 16%, rgba(208, 138, 60, 0.2) 0%, transparent 34%),
    linear-gradient(180deg, #0c0908 0%, #111111 100%);
  color: var(--text-primary);
  min-height: 100vh;
  overflow-x: hidden;
}

/* Media defaults */
img {
  display: block;
  max-width: 100%;
}

/* Interactive defaults */
a,
button {
  transition: all 0.25s ease;
}

#root {
  overflow-x: hidden;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

/* Shared content width helper */
.layout-container {
  width: min(100%, 1200px);
  margin: 0 auto;
}

@media ${device.mobile} {
  body {
    font-size: 15px;
  }
}
`;
